import { GuardianOption } from '../types/delegate';

export const balance: number = 1000000;

export const guardianAmountTotal: number = 40000000;

export const guardiansList: GuardianOption[] = [
  { id: 0, name: 'Guardian1', amount: 5000000 },
  { id: 1, name: 'Guardian2', amount: 33000000 },
  { id: 2, name: 'Guardian3', amount: 4400000 },
  { id: 3, name: 'Guardian4', amount: 20000000 },
  { id: 4, name: 'Guardian5', amount: 16000000 },
  { id: 5, name: 'Guardian6', amount: 18000000 },
  { id: 6, name: 'Guardian7', amount: 19000000 },
];
